module.exports = __webpack_public_path__ + "img/no-data.a9488dcd.svg";